import { deserializeAccount, schemaAccountList, schemaAccountReceive, schemaAccountRequest, } from "@ledgerhq/wallet-api-core";
export class AccountModule {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * List accounts added by user on the connected wallet
     *
     * @param params - Filters for currencies
     *
     * @returns The list of accounts on the connected wallet
     * @throws {@link RpcError} if an error occured on server side
     */
    async list(params) {
        const listAccountsResult = await this.client.request("account.list", {
            currencyIds: params?.currencyIds,
        });
        const safeResults = schemaAccountList.result.parse(listAccountsResult);
        return safeResults.rawAccounts.map(deserializeAccount);
    }
    /**
     * Ask the connected wallet for an account matching a specific set of critterias.
     *
     * @param params - Parameters of the request.
     *
     * @returns The account selected by the user
     * @throws {@link RpcError} if an error occured on server side
     */
    async request(params) {
        const requestAccountsResult = await this.client.request("account.request", {
            currencyIds: params?.currencyIds,
        });
        const safeResults = schemaAccountRequest.result.parse(requestAccountsResult);
        return deserializeAccount(safeResults.rawAccount);
    }
    /**
     * Let user verify it's account address on his device through Ledger Live
     *
     * @param accountId - id of the account
     *
     * @returns The verified address or an error message if the verification doesn't succeed
     */
    async receive(accountId) {
        const receiveAccountsResult = await this.client.request("account.receive", {
            accountId,
        });
        const safeResults = schemaAccountReceive.result.parse(receiveAccountsResult);
        return safeResults.address;
    }
}
//# sourceMappingURL=Account.js.map